<template>
  <div>
    <base-select
      class="select-fiat"
      :model-value="modelValue"
      :options="sortedList"
      :placeholder="$t('CoinDropdown | Placeholder')"
      @update:modelValue="handleSelection"
    >
      <template #trigger>
        <template v-if="activeFiat">
          <div class="fiat-item">
            <svg-icon :name="activeFiat.icon" />
            <span>{{ $t(activeFiat.title) }}</span>
          </div>
        </template>
      </template>

      <template #item="{ data }">
        <div class="fiat-item">
          <svg-icon :name="data.icon" />
          <div class="fiat-item-text">
            <span>{{ $t(data.description) }}</span>
            <span>•</span>
            <span>{{ $t(data.title) }}</span>
          </div>
        </div>
      </template>
    </base-select>
  </div>
</template>

<script>
import BaseSelect from '@emcd-shared/base-select'
import SvgIcon from '@/shared/ui/SvgIcon/SvgIcon.vue'

export default {
  props: {
    // Id of the current selected fiat
    modelValue: {
      type: String,
    },
    // Array with Available fiats
    options: {
      type: Array,
      default: null,
    },
  },

  emits: ['update:modelValue'],

  components: {
    SvgIcon,
    BaseSelect,
  },

  computed: {
    // Selected fiat option description or undefined
    activeFiat() {
      if (!this.modelValue) return undefined
      return this.options.find((option) => option.value === this.modelValue)
    },

    // TODO: Preferred fiat first ?
    sortedList() {
      if (!this.options) return []

      return this.options.map((option) => ({
        ...option,
        optionValue: option.value, // BaseSelect expects optionValue
      }))
    },
  },

  methods: {
    handleSelection(value) {
      this.$emit('update:modelValue', value)
    },
  },
}
</script>

<style scoped lang="scss">
.fiat-item {
  display: flex;
  align-items: center;
  gap: 6px;
}

.fiat-item-text {
  display: flex;
  gap: 5px;
}

.coin-dropdown {
  :deep(button) {
    font-size: 14px;
    color: var(--text-3);

    .base-select--icon {
      color: var(--text-1);
    }
  }

  :deep(.base-select--main) {
    ul {
      .divider-item {
        display: none;
      }
    }
  }

  &__main-icon {
    max-width: 24px;
  }

  &__icon {
    max-width: 30px;
    margin-right: 15px;
  }

  &__main {
    display: flex;
    align-items: center;

    &__desc {
      text-align: start;
      font-size: 14px;
      font-weight: 500;
      color: var(--text-1);
    }
  }

  &__placeholder {
    margin: 10px 0px;
    font-size: 12px;
    color: var(--text-3);
    text-align: start;
  }

  &__title {
    &__name {
      font-size: 12px;
      font-weight: 500;
      color: var(--text-3);
      text-align: start;
    }

    &__desc {
      text-align: start;
      font-size: 16px;
      font-weight: 500;
      color: var(--text-1);
    }
  }

  &__check {
    position: absolute;
    width: 20px;
    height: 20px;
    right: 15px;
  }

  &__search {
    position: relative;
    margin: 0 10px;
    margin-bottom: 10px;

    &__input {
      width: 100%;
      padding: 10px 30px 10px 40px;
      border: 1px solid var(--bg-35);
      border-radius: 8px;
      font-size: 14px;
      color: var(--text-3);
      background: var(--bg-35);
      height: 32px;
    }

    &__input::placeholder {
      color: var(--text-3);
      font-size: 12px;
    }

    &__icon-search {
      position: absolute;
      width: 20px;
      height: 20px;
      left: 10px;
      top: 50%;
      transform: translateY(-50%);
      pointer-events: none;
    }

    &__icon-close {
      z-index: 10;
      position: absolute;
      width: 20px;
      height: 20px;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
      cursor: pointer;
    }
  }

  &__not-found-title {
    font-size: 16px;
    font-weight: 500;
    color: var(--text-1);
    text-align: center;
    margin-top: 40px;
  }

  &__not-found-desc {
    font-size: 12px;
    font-weight: 500;
    color: var(--text-3);
    text-align: center;
    margin-top: 5px;
    margin-bottom: 40px;
  }

  &__send-email {
    font-size: 12px;
    font-weight: 500;
    color: var(--text-3);
    text-align: center;
    margin-top: 80px;
    margin-bottom: 25px;
  }

  &__email {
    color: var(--active-link);
  }
}
</style>
